$('.category-list__link').click(function (e) {
  e.preventDefault();

  let href = $(this).attr('href');

  //делаем текущий элемент визуально активным
  $('.category-list__item--active').removeClass('category-list__item--active');
  $(this).closest('li').addClass('category-list__item--active');
  $('.category-list__link-wrap').css('border-bottom', '1px solid #EBEBEB');
  $('.category-list__item--active').children('.category-list__link-wrap').css('border-bottom', '1px solid #F7F7F7');
  $('.category-list__item--active').prev('.category-list__item').children('.category-list__link-wrap').css('border-bottom', '1px solid #fff');
  $('.category-list__item').last().children('.category-list__link-wrap').css('border-bottom', '1px solid #fff');

  //скрываем контент неактивных категорий
  $('.category-content').removeClass('category-content--active');

  //показываем контент категории
  $(href).addClass('category-content--active');
});



// WEBPACK FOOTER //
// ./app/blocks/faq-list/faq-list.js